import React from "react";
import { getData } from "app/data";
import MerchantService from "components/MerchantService";
import CommonUseCases from "components/CommonUseCases";
import WaitingFor from "components/Banner/WaitingFor";
import "./useCases.css";
import ContentsTwoColumn from "components/MerchantService/ContentsTwoColumn";
import HeaderBackground from "components/BackGround/HeaderBackground";


export default function Index() {
    const titleData = getData("browseByUseCaseDataTitles")[1];
    const contents = getData("browseByUseCaseData2and3");
    return (
        <div className="use-case-2-page">
            <HeaderBackground />
            <MerchantService data={titleData} header={true} />
            <div className="background">
                <ContentsTwoColumn data={contents} posName="browseByUseCase" />
            </div>
            <CommonUseCases data="posDevicesData" />
            <WaitingFor />
        </div>
    );
}
